import type {
  BaseResponse,
  Event,
  EventGuest,
  EventRsvpActivity,
  KnownPackageName,
  Package,
} from "@anggunpraya-templates/types";
import type { DeepPartial } from "@nuxt/ui/runtime/types/utils.js";

interface PreviewInvitationData {
  eventDetail: BaseResponse<DeepPartial<Event>>;
  eventGuest: DeepPartial<EventGuest>;
}

const DEFAULT_SUBDOMAIN = "fulanfulanah";
const DEFAULT_EVENT_RSVP_ACTIVITY: DeepPartial<EventRsvpActivity>[] = [
  {
    rsvp_activity: {
      rsvp_activity_id: "AP-RA-001",
      name: "Akad Nikah",
    },
  },
  {
    rsvp_activity: {
      rsvp_activity_id: "AP-RA-002",
      name: "Resepsi Pernikahan",
    },
  },
];
const DEFAULT_PACKAGE: Package = {
  package_id: "AP-PK-001",
  name: "Celebration",
  include_user_dashboard: true,
  include_rsvp: true,
  price: 0,
  created_at: "",
  updated_at: "",
};

function resolvedPackage(packageName: KnownPackageName): Package & {
  rsvp_enabled: boolean;
} {
  const isCelebration = packageName === "Celebration";

  return {
    ...DEFAULT_PACKAGE,
    name: packageName,
    rsvp_enabled: isCelebration,
    include_rsvp: isCelebration,
    include_user_dashboard: isCelebration,
  };
}

export function createPreviewInvitationData(options: { templateCode: string; packageName: KnownPackageName }): PreviewInvitationData {
  const { templateCode, packageName } = options;

  const baseUrl = `https://${DEFAULT_SUBDOMAIN}.anggunpraya.id`;
  const resolvedPackageData = resolvedPackage(packageName);

  return {
    eventDetail: {
      success: true,
      error: null,
      paging: null,
      data: {
        code: templateCode,
        groom_name: "Fulan",
        bride_name: "Fulanah",
        date: "2025-10-12T02:00:00.000Z",
        rsvp_deadline: "2025-10-08T23:59:59.000Z",
        subdomain: DEFAULT_SUBDOMAIN,
        url: baseUrl,
        rsvp_enabled: true,
        event_rsvp_activity: DEFAULT_EVENT_RSVP_ACTIVITY,
        package: resolvedPackageData,
      },
    },

    eventGuest: {
      name: "Fulan",
      status: "unconfirmed",
      attending_with: "family",
      created_at: "",
      phone_number: "",
      updated_at: "",
      total_pax: 0,
      event: null,
      code: templateCode,
      event_guest_id: templateCode,
      event_id: templateCode,
      url: `${baseUrl}/${templateCode.toLowerCase()}`,
      is_rsvp: resolvedPackageData.include_rsvp,
      event_guest_rsvp_activity: DEFAULT_EVENT_RSVP_ACTIVITY.map((item, index) => {
        return {
          rsvp_activity: item.rsvp_activity,
          rsvp_status: "pending",
          pax: 0,
          egra_id: `AP-GA-00${index + 1}`,
        };
      }),
    },
  };
}
